<div
  class="d-inline-block fw-normal me-2 pointer-hover"
  (click)="this.onClickOnElement()"
>
  <i
    class="{{ this.icon }}"
    [class.color-orange]="this.statusMode === 'alarm'"
  ></i>

  <span [class.color-orange]="this.statusMode === 'alarm'">
    {{ this.title }}
  </span>

  @if (this.mode) {
    <b class="fw-bold d-inline-block mx-2 {{ modeColor }}">{{ this.mode }}</b>
  }

  @if (status || content) {
    <div
      class="d-inline-block text-center position-relative default-content"
      style="line-height: 16px; height: 24px; border-radius: 12px"
      [style.background-color]="getBackgroundColorFromColor()"
    >
      <div class="h-100 px-2">
        <div class="row m-0 h-100 justify-content-center align-items-center">
          <div class="col p-0 text-center  {{ color }}">
            <i class="{{ content }}"></i> {{ status }}
          </div>
        </div>
      </div>
    </div>
  }
</div>
